import React from "react";
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import * as moment from "moment/moment";

import {greyishBlue600} from "assets/jss/main";

import {capitalize} from "utils/capitalize";

export default function GreetMessage({name}) {
    const date = new Date();
    const hours = date.getHours();

    const givenName = capitalize(name);

    let dayMoment = 'morning'

    if (name) {
        if (hours < 6) {
            dayMoment = 'night';
        } else if (hours > 12 && hours <= 17) {
            dayMoment = 'afternoon';
        } else if (hours > 17 && hours < 24) {
            dayMoment = 'evening';
        }
    }

    return (
        <div style={{fontSize: "28px"}}>
            <FormattedMessage
                id={`dashboard.title.greeting.${dayMoment}`}
                values={{name: givenName}}
            />
            <div style={{
                paddingTop: "5px",
                color: greyishBlue600,
                fontSize: "14px"
            }}>
                <FormattedMessage
                    id={"dashboard.subtitle"}
                    values={{date: moment(new Date()).format("D MMMM")}}
                />
            </div>
        </div>
    )
}

GreetMessage.defaultProps = {
    name: ""
};

GreetMessage.propTypes = {
    name: PropTypes.string.isRequired
};
